/**
 * Where a signed-in user lands when no route is asked for, and where a
 * ProtectedRoute sends them when they lack its permission. One place so the
 * shell and the route guard never disagree.
 */
export function defaultLandingPath(can: (permission: string) => boolean): string {
  if (can('dashboard.view')) return '/dashboard';
  if (can('groups.view')) return '/my-groups';
  // Kindergarten staff hold nothing from the CRM itself.
  if (can('kindergarten.view')) return '/kindergarten';
  // A live check-in volunteer holds nothing but communion.record.
  if (can('communion.record')) return '/communion/live';
  return '/my-groups';
}
